import React from 'react';
import { BsFillImageFill, BsFillXCircleFill } from 'react-icons/bs';
import { Server } from '../../server/server';
import { getBannerImage, getPortraitImage } from '../util/user';
import MessageModal from './MessageModal';
import AlertModal from './AlertModal';
import AddMediaModal from './AddMediaModal';
import './Modal.css'
import './EditProfileModal.css'

interface EditProfileModalProps {
  open: boolean;
  onClose: Function;
}

interface EditProfileModalState {
  changeBanner: boolean;
  changePortrait: boolean;
  banner: string;
  portrait: string;
  name: string;
  slug: string;
  bio: string;
  message: string;
  alert: string;
  openBannerList: boolean;
  openPortraitList: boolean;
  openAddMedia: boolean;
  editPortrait: boolean;
  editBanner: boolean;
}

class EditProfileModal extends React.Component<EditProfileModalProps, EditProfileModalState> {
  constructor(props:EditProfileModalProps) {
    super(props);

    this.state = {
      changeBanner: false,
      changePortrait: false,
      banner: '',
      portrait: '',
      name: '',
      slug: '',
      bio: '',
      message: '',
      alert: '',
      openBannerList: false,
      openPortraitList: false,
      openAddMedia: false,
      editPortrait: false,
      editBanner: false
    };

    this.onOpenBannerList = this.onOpenBannerList.bind(this);
    this.onCloseBannerList = this.onCloseBannerList.bind(this);
    this.onOpenPortraitList = this.onOpenPortraitList.bind(this);
    this.onClosePortraitList = this.onClosePortraitList.bind(this);
    this.onChangeName = this.onChangeName.bind(this);
    this.onChangeSlug = this.onChangeSlug.bind(this);
    this.onChangeBio = this.onChangeBio.bind(this);
    this.onSaveProfile = this.onSaveProfile.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  componentDidMount(): void {
    this.resetState();
  }

  resetState() {
    this.setState({
      changeBanner: false,
      changePortrait: false,
      banner: Server.user.getBanner(),
      portrait: Server.user.getPortrait(),
      name: Server.user.getName(),
      slug: Server.user.getSlug(),
      bio: Server.user.getBio(),
      message: '',
      alert: '',
      openBannerList: false,
      openPortraitList: false
    });
  }

  onOpenBannerList() {
    this.setState({openBannerList: true});
  }

  onCloseBannerList(banner:string) {
    let b = banner ? banner : this.state.banner;
    this.setState({openBannerList: false, banner: b});
  }
  
  onOpenPortraitList() {
    this.setState({openPortraitList: true});
  }

  onClosePortraitList(portrait:string) {
    let p = portrait ? portrait : this.state.portrait;
    this.setState({openPortraitList: false, portrait: p});
  }

  onOpenAddMedia(category:string) {
    let editPortrait = (category == 'portrait');
    let editBanner = (category == 'banner');
    this.setState({openAddMedia: true, editPortrait, editBanner});
  }

  onCloseAddMedia(data:any) {
    console.log(data);
    let portrait = this.state.editPortrait ? data.url : this.state.portrait;
    let banner = this.state.editBanner ? data.url : this.state.banner;
    this.setState({portrait, banner, openAddMedia: false});
  }
  
  onChangeName(e:any) {
    this.setState({name: e.currentTarget.value});
  }

  onChangeSlug(e:any) {
    this.setState({slug: e.currentTarget.value});
  }

  onChangeBio(e:any) {
    this.setState({bio: e.currentTarget.value});
  }

  onSaveProfile() {
    let dirty = false;
    if(this.state.name != Server.user.getName()) dirty = true;
    if(this.state.bio != Server.user.getBio()) dirty = true;
    if(this.state.slug != Server.user.getSlug()) dirty = true;
    if(this.state.banner != Server.user.getBanner()) dirty = true;
    if(this.state.portrait != Server.user.getPortrait()) dirty = true;

    if(!dirty) {
      this.props.onClose();
      return;
    }

    let errorMsg = '';

    if(this.state.name.length < 3) 
      errorMsg = 'Name must be at least 3 characters.';

    if(this.state.slug.length < 3) 
      errorMsg = 'Handle must be at least 3 characters.';

    if(this.state.slug.length > 32) 
      errorMsg = 'Handle must be at most 32 characters.';
  
    if(this.state.slug.indexOf('--') != -1) 
      errorMsg = 'Handle cannot contain consecutive dash (-) characters.';
      
    let re = /^[a-zA-Z0-9-]+$/;
    if(!re.test(this.state.slug)) 
      errorMsg = 'Handle may only contain a-z, A-Z, 0-9, and dash (-) characters.';

    if(errorMsg != '') {
      this.setState({alert: errorMsg});        
      return;
    }

    this.setState({message: 'Saving profile...'});

    setTimeout(async () => {
      let params:any = {};

      if(this.state.name != Server.user.getName()) 
        params.name = this.state.name;

      if(this.state.bio != Server.user.getBio())
        params.bio = this.state.bio;

      if(this.state.slug != Server.user.getSlug())
        params.slug = this.state.slug;

      if(this.state.banner != Server.user.getBanner())
        params.banner = this.state.banner;

      if(this.state.portrait != Server.user.getPortrait())
        params.portrait = this.state.portrait;
  
      let response = await Server.user.setProfile(params);
      
      if(response.success) {
        let profile = Server.user.getProfile();
        Server.public.addProfileToCache(profile);
        this.setState({message: ''});
        this.props.onClose();
      }
      else {
        this.setState({message: '', alert: response.message});
      }
    }, 500);
  }

  onClose() {
    this.resetState();
    this.props.onClose();
  }

  render() {
    if(!this.props.open)
      return (<div></div>);

    let bannerImage = this.state.banner ? this.state.banner : getBannerImage(null);
    let portraitImage = this.state.portrait ? this.state.portrait : getPortraitImage(null);

    return (
      <div className="modal open">
        <div className="modal-content edit-profile-modal-content">
          <button className="modal-close-button" onClick={this.onClose}>
            <BsFillXCircleFill />
          </button>
          <div className="edit-profile-modal-header">Edit Profile</div>
          <div>
            <div className="edit-profile-banner-container">
              <img className="edit-profile-banner" src={bannerImage} />
              {portraitImage && 
                <img className="edit-profile-portrait" src={portraitImage} />
              }
              <div className="edit-profile-change-banner" onClick={()=>this.onOpenAddMedia('banner')}>
                <BsFillImageFill />
              </div>
              <div className="edit-profile-change-portrait" onClick={()=>this.onOpenAddMedia('portrait')}>
                <BsFillImageFill />
              </div>
            </div>

            <div className='edit-profile-input-container'>
              <div className='edit-profile-input-row'>
                <div className='edit-profile-label'>Name</div>
                <input
                  className="edit-profile-input"
                  placeholder="Name"
                  value={this.state.name}
                  onChange={this.onChangeName}
                />
              </div>

              <div className='edit-profile-input-row'>
                <div className='edit-profile-label'>Handle</div>
                <input
                  className="edit-profile-input"
                  placeholder="Name"
                  value={this.state.slug}
                  onChange={this.onChangeSlug}
                />
              </div>                

              <div className='edit-profile-input-row'>
                <div className='edit-profile-label'>Bio</div>
                <textarea
                  className="edit-profile-textarea"
                  placeholder="Bio"
                  value={this.state.bio}
                  onChange={this.onChangeBio}
                />
              </div>

              <div>
                <button onClick={this.onSaveProfile}>Save</button>
              </div>
            </div>

          </div>
        </div>
        <MessageModal message={this.state.message} />
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})}/>
        <AddMediaModal open={this.state.openAddMedia} onClose={()=>this.setState({openAddMedia: false})} callback={(data:any)=>this.onCloseAddMedia(data)} />
      </div>
    )
  }
}

export default EditProfileModal;